// window.theme = window.theme || {};
// theme.slideshowSection = () => {
//   let slideshowEle = document.querySelectorAll('.slideshow-wrapper.swiper');
//   slideshowEle.forEach(current => {
//     let swiperOptions = JSON.parse(current.dataset.sliderOptions);
//     swiperOptions.on = {
//       slideChange: function (e) {
//         let allAnimateEles = e.wrapperEl.querySelectorAll('[mag-animation]');
//         allAnimateEles.forEach(ele => {
//           ele.classList.remove('mag-animated');
//         })
//         setTimeout(() => {
//           theme.onScrollAnimation();
//         }, 250);
//       }
//     }
//     swiper = new Swiper(current, swiperOptions);

//     current.addEventListener('mouseover', () => {
//       swiper.autoplay.stop();
//     })
//     current.addEventListener('mouseleave', () => {
//       swiper.autoplay.start();
//     })


//     // pause slideshow on block select
//     if (Shopify.designMode) {
//       document.addEventListener('shopify:block:select', (e) => {
//         let shopifyData = JSON.parse(e.target.dataset.shopifyEditorBlock),
//           targetEle = e.target,
//           sliderIndex = 1 + parseInt(targetEle.dataset.swiperSlideIndex);
//         swiper.slideTo(sliderIndex);
//         swiper.autoplay.stop();
//       })
//       const customizationEvents = ['shopify:inspector:activate', 'shopify:inspector:deactivate', 'shopify:section:load', 'shopify:block:deselect', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect', 'shopify:inspector:activate', 'shopify:inspector:deactivate'];

//       customizationEvents.forEach(event => {
//         document.addEventListener(event, () => swiper.init(swiperOptions));
//       })
//     }
//   })
// }

// // On-scroll animation
// theme.onScrollAnimation = () => {
//   let animationEle = document.querySelectorAll('[mag-animation]');
//   let animationObserver = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         let animationDelay = entry.target.dataset?.magDelay;
//         if (animationDelay) {
//           animationDelay = parseInt(animationDelay)
//           setTimeout(() => {
//             entry.target.classList.add('mag-animated');
//           }, animationDelay);
//         } else {
//           entry.target.classList.add('mag-animated');
//         }
//       }
//     })
//   }, { threshold: [0.25] });
//   animationEle.forEach(ele => {
//     animationObserver.observe(ele);
//   });
// }

// window.addEventListener('DOMContentLoaded', () => {
//   theme.slideshowSection();
// })

// document.addEventListener('cart:sections-updated', () => {
//   if (typeof theme?.slideshowSection !== 'function') return;
//   requestAnimationFrame(() => {
//     theme.slideshowSection();
//   });
// });

window.theme = window.theme || {};
theme.slideshowSection = () => {
  let slideshowEle = document.querySelectorAll('.slideshow-wrapper.swiper');
  slideshowEle.forEach(current => {
    let swiperOptions = JSON.parse(current.dataset.sliderOptions);
    swiperOptions.on = {
      slideChange: function (e) {
        let allAnimateEles = e.wrapperEl.querySelectorAll('[mag-animation]');
        allAnimateEles.forEach(ele => {
          ele.classList.remove('mag-animated');
        })
        setTimeout(() => {
          theme.onScrollAnimation();
        }, 250);
      }
    }
    requestAnimationFrame(() => {
      swiper = new Swiper(current, swiperOptions);

      current.addEventListener('mouseover', () => {
        swiper.autoplay.stop();
      })
      current.addEventListener('mouseleave', () => {
        swiper.autoplay.start();
      })

      // pause slideshow on block select
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          let shopifyData = JSON.parse(e.target.dataset.shopifyEditorBlock),
            targetEle = e.target,
            sliderIndex = 1 + parseInt(targetEle.dataset.swiperSlideIndex);
          swiper.slideTo(sliderIndex);
          swiper.autoplay.stop();
        })
        const customizationEvents = ['shopify:inspector:activate', 'shopify:inspector:deactivate', 'shopify:section:load', 'shopify:block:deselect', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect', 'shopify:inspector:activate', 'shopify:inspector:deactivate'];

        customizationEvents.forEach(event => {
          document.addEventListener(event, () => swiper.init(swiperOptions));
        })
      }
    }); // requestAnimationFrame end

  })
}

// On-scroll animation
theme.onScrollAnimation = () => {
  let animationEle = document.querySelectorAll('[mag-animation]');
  let animationObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let animationDelay = entry.target.dataset?.magDelay;
        if (animationDelay) {
          animationDelay = parseInt(animationDelay)
          setTimeout(() => {
            entry.target.classList.add('mag-animated');
          }, animationDelay);
        } else {
          entry.target.classList.add('mag-animated');
        }
      }
    })
  }, { threshold: [0.25] });
  animationEle.forEach(ele => {
    animationObserver.observe(ele);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(() => {
    theme.slideshowSection();
  });
})

document.addEventListener('cart:sections-updated', () => {
  if (typeof theme?.slideshowSection !== 'function') return;
  requestAnimationFrame(() => {
    theme.slideshowSection();
  });
});